export default {
  password(val) {
    if (!val || 8 > val.length || val.length > 32) {
      return "Password must be between 8 and 32 symbols";
    }
    return "";
  },
  email(val) {
    let atIndex = val ? val.indexOf("@") : -1;
    let dotIndex = val ? val.indexOf(".") : -1;
    if (!val || atIndex < 0 || dotIndex < 0 || atIndex > dotIndex) {
      return "Enter a valid email";
    }
    return "";
  },
  required(val, customMessage = "This field is required!") {
    if (!val) {
      return customMessage;
    }
    return "";
  }
};
